const API = '/loopback/api'

export default {
  api: API
}



// WEBPACK FOOTER //
// ./src/config.js